import React from 'react';

export const WbPartnersLogo = () => {
  return (
    <svg
      fill="none"
      height="100%"
      viewBox="0 0 133 36"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.52213 25.1051L0.0527344 13.4051H3.04793L5.69213 20.1677L8.31293 13.4051H10.1147L12.7823 20.2145L15.4265 13.4051H18.2813L13.8119 25.1051H11.9165L9.17873 18.0851L6.41753 25.1051H4.52213Z"
        fill="#7F30E3"
      />
      <path
        d="M25.3083 25.5029C21.9387 25.5029 19.0371 22.7183 19.0371 19.2083V7.78906H21.8217V14.6687C22.6875 13.6625 24.0681 12.9839 25.7061 12.9839C28.9587 12.9839 31.6965 15.7685 31.6965 19.2083C31.6965 22.7183 28.7949 25.5029 25.3083 25.5029ZM25.3083 22.7183C27.2505 22.7183 28.9353 21.2207 28.9353 19.2083C28.9353 17.2895 27.3207 15.7217 25.3785 15.7217C23.3895 15.7217 21.8217 17.2895 21.8217 19.2083C21.8217 21.2207 23.4831 22.7183 25.3083 22.7183Z"
        fill="#7F30E3"
      />
      <path
        d="M63.3492 14.5515C62.3868 13.5551 61.0811 12.919 59.5 12.919C55.9257 12.919 53.4001 15.7026 53.4001 19.1563C53.4001 22.6443 55.9257 25.3935 59.5 25.3935C61.0807 25.3935 62.4039 24.7922 63.3492 23.8298V24.9983H66.1328V13.3138H63.3492V14.5515ZM59.7749 22.7135C57.8331 22.7135 56.2181 21.2013 56.2181 19.1566C56.2181 17.129 57.8331 15.6342 59.7749 15.6342C61.6994 15.6342 63.3492 17.1804 63.3492 19.1566C63.3492 21.1329 61.6823 22.7135 59.7749 22.7135Z"
        fill="black"
      />
      <path
        d="M70.1877 15.9265V13.3146H67.4386V24.9991H70.1877V19.9473C70.1877 17.6104 72.6964 16.1844 75.2394 16.1844V13.315H74.9301C72.8336 13.315 71.3388 14.1397 70.1873 15.9268L70.1877 15.9265Z"
        fill="black"
      />
      <path
        d="M46.2693 12.902C42.9011 12.902 40.0146 15.6856 40.0146 19.191V30.6006H42.7982V24.2946C43.8979 24.9647 45.0149 25.4116 46.4236 25.4116C49.9116 25.4116 52.6608 22.6107 52.6608 19.1744C52.6438 15.6689 49.7399 12.9028 46.2689 12.9028L46.2693 12.902ZM46.4069 22.6103C44.3104 22.6103 42.7812 21.0981 42.7812 19.1737C42.7812 17.1634 44.4481 15.6682 46.2693 15.6682C48.2111 15.6682 49.8946 17.163 49.8946 19.1737C49.8776 21.0981 48.3487 22.6103 46.4069 22.6103Z"
        fill="black"
      />
      <path
        d="M115.276 15.9265V13.3146H112.526V24.9991H115.276V19.9473C115.276 17.6104 117.784 16.1844 120.328 16.1844V13.315H120.018C117.922 13.315 116.427 14.1393 115.276 15.9265Z"
        fill="black"
      />
      <path
        d="M93.6252 12.8676C92.1473 12.8676 90.9618 13.5377 90.1027 14.3624V13.3142H87.3191V22.2147H81.3398V15.8573H85.9619V13.3142H81.3398V8.64062H78.5562V13.3142H76.0816V15.8573H78.5562V22.2147C78.5562 23.5893 79.3983 24.9983 81.3398 24.9983H90.1031V19.1733C90.1031 17.0768 91.512 15.5994 93.2992 15.5994C94.794 15.5994 95.8078 16.51 95.8078 18.572V24.9983H98.6602V18.572C98.6428 15.6682 97.4059 12.8672 93.6255 12.8672L93.6252 12.8676Z"
        fill="black"
      />
      <path
        d="M126.737 17.7476C125.328 17.61 124.263 17.4897 124.263 16.7682C124.263 15.9265 125.225 15.3592 126.479 15.3592C127.888 15.3592 129.228 16.0637 130.225 17.0431L131.909 14.9467C130.225 13.5891 128.713 12.8676 126.6 12.8676C124.125 12.8676 121.462 13.9847 121.462 16.7682C121.462 19.947 124.263 20.2563 126.6 20.3939C127.888 20.5312 128.954 20.6689 128.954 21.4936C128.954 22.3358 127.734 22.7309 126.6 22.7309C125.225 22.7309 123.816 22.1981 122.699 20.9268L120.895 22.92C122.441 24.5525 124.538 25.3942 126.48 25.3942C128.954 25.3942 131.738 24.1569 131.738 21.3734C131.738 18.2634 128.954 18.04 126.737 17.7476H126.737Z"
        fill="black"
      />
      <path
        d="M105.757 12.868C102.269 12.868 99.502 15.4799 99.502 18.985C99.502 22.49 101.977 25.3942 105.585 25.3942C107.853 25.3942 109.674 24.2946 110.912 22.473L108.66 20.8061C107.99 21.8888 106.856 22.6103 105.568 22.6103C104.073 22.6103 102.561 21.4932 102.406 19.8267H111.444V18.9846C111.462 15.3763 109.073 12.8676 105.757 12.8676L105.757 12.868ZM102.715 17.4901C103.231 16.3216 104.21 15.6686 105.568 15.6686C107.131 15.6686 107.973 16.3216 108.42 17.4901H102.715Z"
        fill="black"
      />
    </svg>
  );
};
